import {Routes} from '@angular/router';

export const orderManagementRoutes: Routes = [
  {
    path: 'orderManagement',
    data: { title: '订单管理' },
    children: [
      {
        path: '',
        loadComponent: () => import('./order-management.component').then(m => m.OrderManagementComponent),
        data: { title: '订单管理' },
      },
      {
        path: 'orderDetail/:orderId',
        loadComponent: () => import('./order-detail/order-detail.component').then(m => m.OrderDetailComponent),
        data: { title: '订单明细管理' },
      },
      {
        path: 'orderAdd',
        loadComponent: () => import('./order-add/order-add.component').then(m => m.OrderAddComponent),
        data: { title: '新建订单' },
      },
    ]
  },
];
